import { apiFetch, apiJson, apiUrl, isSuccess } from "./apiClient";

export async function getProfile() {
  let response;
  try {
    response = await apiFetch(apiUrl("/profiles"));
  } catch (error) {
    console.error("Profile fetch error:", error);
    return null;
  }
  if (isSuccess(response)) {
    return response.json();
  }
  // Return null for any error status (auth, server errors, etc)
  console.error(`Failed to get profile: ${response.status}`);
  return null;
}

export function getAdminStatus() {
  return apiJson(apiUrl("/profiles/getAdminStatus"));
}

export async function getDealershipUsers(dealerCode) {
  try {
    const response = await apiFetch(apiUrl(`/profiles/users/${dealerCode}`));
    if (isSuccess(response)) {
      return await response.json();
    }
    if (response.status === 401 || response.status === 403) {
      return [];
    }
    console.log(`Error getting dealership users: ${response.status}`);
    throw new Error(`Failed to get dealership users: ${response.status}`);
  } catch (error) {
    console.error("Dealership users fetch error:", error);
    return [];
  }
}

export async function getDealership(dealerCode) {
  const response = await apiFetch(apiUrl(`/profiles/dealership/${dealerCode}`));
  if (isSuccess(response)) {
    return response.json();
  }
  console.log(`Error getting dealership name: ${response}`);
  throw response;
}

export async function postUserProfileImage(file) {
  if (file == null) {
    return;
  }

  const formData = new FormData();
  formData.append("userfile", file);

  return apiJson(apiUrl("/profiles/image"), {
    option: "POSTFILE",
    body: formData,
  });
}

export function postUserData(userData) {
  return apiJson(apiUrl("/profiles/"), {
    option: "POST",
    body: { userData },
  });
}
